import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useMasterDataAddUserContext } from "./MasterDataUserUIContext";
// import { shallowEqual, useSelector } from "react-redux";
import MasterDataUserTable from "./master-data-user-table/MasterDataUserTable";
import { RoleChecker } from "../../../../RoleChecker";
import { Collapse } from "react-bootstrap";
import { MasterDataUserFilter } from "./master-data-user-table/master-data-user-filter/MasterDataUserFilter";
// import { fetchUsersBySuperAdmin } from "../../_redux/master-data-user/masterDataUserAction";

export const MasterDataUserCard = () => {
  const [openFilter, setOpenFilter] = useState(false);

  const masterDataUserContext = useMasterDataAddUserContext();
  const masterDataUIProps = useMemo(() => {
    return {
      addNewUser: masterDataUserContext.addNewUser
    };
  }, [masterDataUserContext]);

  const allowCreate = RoleChecker("Create", "master_data_user");
  const allowEdit = RoleChecker("Edit", "master_data_user");

  return (
    <>
      <Card>
        <CardHeader title="User">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={masterDataUIProps.addNewUser}
              >
                Tambah User
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <MasterDataUserFilter />
            </div>
          </Collapse>
          <MasterDataUserTable allowEdit={allowEdit} />
        </CardBody>
      </Card>
    </>
  );
};
